import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as MailboxIn } from '../../assets/images/svg/mailbox-in.svg';
import themeColors from '../../assets/styles/themeColors';

const MailboxInStyled = styled(MailboxIn)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
  stroke: ${themeColors.colorTextPrimary};

  circle {
    stroke: none;
  }
`;

const MailboxInIcon = (props) => <MailboxInStyled {...props} />;

MailboxInIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

MailboxInIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default MailboxInIcon;
